import React from 'react'
import {connect} from 'react-redux'
import {Marker, Popup} from 'react-leaflet'

import setMap from '../actions/setMap'

const MapSetter = ({map,doSetMap}) => {
  doSetMap()
  return <div/>
}

const mapStateToProps = state => {
  return { }
}
const mapDispatchToProps = (dispatch, ownProps) => {
  return {  
    doSetMap: _ => {
      dispatch(setMap(ownProps.map))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MapSetter)




/** WEBPACK FOOTER **
 ** ./app/components/MapSetter.jsx
 **/